module.exports = __webpack_public_path__ + "assets/bf8f3590c6ef0411f133eb1b8ca99fa6.png";